//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Fields.js";
import "../Fields/Fields.Field.js";
let d=[[[0,"Discontinuities",0,0],[0,"ValuesOutsideTableInterpolation",1,0]],[[["indep_var_array","dep_var_array","datapoints","link_fields_array"],"EditFieldLinksTable",{},4,0],[["indep_var_array","dep_var_array","datapoints","link_fields_array","managed_fields_array"],"EditFieldLinksTable1",{},5,0],[["indep_var_array","dep_var_array","datapoints","link_fields_array","managed_fields_array"],"EditFieldLinksTableWithConstants",{},5,0],[["interpolationMethod"],"SetSecondaryValuesOutsideTableInterpolation",{},1,0],[[],"GetPrimaryIndependentVariableScaleFactor",{R_:{scaleFactor:"Expression"}},0,0],[["scaleFactor"],"SetPrimaryIndependentVariableScaleFactor",{},1,0],[[],"GetPrimaryIndependentVariableOffset",{R_:{offset:"Expression"}},0,0],[["offset"],"SetPrimaryIndependentVariableOffset",{},1,0]],[]];
SPLM.Fields.FieldLinksTable = class extends SPLM.Fields.Field{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Fields.FieldLinksTable";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;